"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Transaction_1 = require("../models/Payments/Transaction");
exports.capitalize = function (word) { return word.charAt(0).toUpperCase() + word.slice(1); };
exports.paymentNameFormatter = function (paymentTypeId) {
    switch (paymentTypeId) {
        case Transaction_1.PaymentTypeIds.etransfer:
            return 'E-Transfer';
        case Transaction_1.PaymentTypeIds.blazepay:
            return 'BLAZEPAY';
        default:
            return exports.capitalize(Transaction_1.PaymentTypeIds[paymentTypeId]);
    }
};
exports.productName = function (_a) {
    var name = _a.name, parentProductName = _a.parentProductName;
    return (parentProductName
        ? parentProductName + " - " + name
        : name);
};
//# sourceMappingURL=string.js.map